import React, { ReactNode, useRef } from "react";
import { Button } from "@mantine/core";

interface SlideComponentProps {
  children: ReactNode[];
  visible?: number; // number of items visible in viewport
  gap?: number; // gap between slides
}

const SlideComponent: React.FC<SlideComponentProps> = ({
  children,
  visible = 3,
  gap = 16,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const scrollAmount = containerWidth / visible; // scroll by one slide
      containerRef.current.scrollBy({
        left: direction === "right" ? scrollAmount + gap : -scrollAmount - gap,
        behavior: "smooth",
      });
    }
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {/* Prev Button */}
      <Button
        size="xs"
        variant="outline"
        style={{
          position: "absolute",
          left: -40,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
        onClick={() => scroll("left")}
      >
        {"<"}
      </Button>

      {/* Next Button */}
      <Button
        size="xs"
        variant="outline"
        style={{
          position: "absolute",
          right: -40,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
        onClick={() => scroll("right")}
      >
        {">"}
      </Button>

      <div
        ref={containerRef}
        style={{
          display: "flex",
          overflow: "hidden",
          gap: `${gap}px`,
          scrollSnapType: "x mandatory",
          scrollBehavior: "smooth",
          padding: `8px ${gap}px`,
        }}
      >
        {React.Children.map(children, (child) => (
          <div
            style={{
              flex: `0 0 calc((100% - ${(visible - 3) * gap}px) / ${visible})`,
              scrollSnapAlign: "start",
            }}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SlideComponent;
